import { ITagAlias, ITagToMetadataDictionary } from "../data_point/models/TagsModels";

export type InverterCapacityKw = number;
export type TrackerName = string;
export type DeviceId = number;

export type DevicesMap<T> = { [deviceId: DeviceId]: T };
export type TrackerNamesMap = DevicesMap<TrackerName | null | undefined>;

export interface ISitesMetadataDictionary {
  [siteId: string]: ISiteMetadata;
}
export enum SiteTrackerType {
  GPT = "GPT",
  SPT = "SPT",
}

export enum TrackerVendor {
  Solargik = "Solargik",
  SolarFirst = "SolarFirst",
  FixedTilt = "FixedTilt",
}

export const isNonSolargikVendor = (trackerVendor?: TrackerVendor): boolean =>
  trackerVendor != null && trackerVendor !== TrackerVendor.Solargik;

export enum PowerMeterType {
  None = 0,
  Total = 1,
  Moment = 2,
}

export enum WeatherSensorFeatures {
  None = 0,
  WindSpeed = 1 << 0,
  WindDirection = 1 << 1,
  Irradiation = 1 << 2,
  IrradiationInstalledOnTracker = 1 << 3,
  IrradiationFixedTilt = 1 << 4,
  Temperature = 1 << 5,
  TemperatureInstalledOnPanel = 1 << 6,
  Barometric = 1 << 7,
  RelativeHumidity = 1 << 8,
  Snow = 1 << 9,
  IrradiationTemperatureCompensated = 1 << 10,
}

export enum AgriSensorManufacturerType {
  Unknown = 0,
  CwtSoil = 1,
  CwtPhotoSynth = 2,
  CwtRainGauge = 3,
  HondeGrowthSensor = 4,
  SenTecSoil = 5,
  Dr3Growth = 6,
}

export interface IWeatherSensorInfo {
  features: WeatherSensorFeatures;
  name?: string;
}

export interface IAgriSensorInfo {
  manufacturerType: AgriSensorManufacturerType;
  name?: string;
}

export interface ISiteAddress {
  country?: string;
  fullAddress?: string;
}

export interface IBusinessInfo {
  siteStage?: string;
  contractType?: string;
  customerId?: number;
}

export interface ISiteMetadata {
  siteId: string;
  siteCode: string;
  displayName: string;
  numberOfTrackers: number;
  address: ISiteAddress;
  ianaTimeZoneName: string;
  dcCapacityKiloWatt?: number;
  acCapacityKiloWatt?: number;
  trackers: DevicesMap<TrackerName | null | undefined>;
  powerMeters: DevicesMap<PowerMeterType>;
  inverters: DevicesMap<InverterCapacityKw>;
  weatherSensors: DevicesMap<IWeatherSensorInfo>;
  agriSensors: DevicesMap<IAgriSensorInfo>;
  trackerType?: SiteTrackerType;
  trackerVendor?: TrackerVendor;
  sprinklersIds: number[];
  upsExists: boolean;
  tags: ITagToMetadataDictionary;
  tagAliases: { [alias: string]: ITagAlias };
  cameras: ICameraMetadata[];
  businessInfo: IBusinessInfo;
  iotHubDeviceNames: string[];
  hasSingleMagnetTrackers: boolean;
}

export interface ICameraMetadata {
  id: number;
  agentId?: number;
  model: string;
  name: string;
}

export type ICameraWithAgentMetadata = ICameraMetadata & { agentId: number };
